//=====================================================================
// Run the distance from top functions (functionToRun)
//=====================================================================
export function runFunctionInView(functionToRun, itemDistanceFromTop, itemFromTopArray, pageScrollPosition, bufferAbove, index) {
    if (itemDistanceFromTop + bufferAbove <= pageScrollPosition &&
        pageScrollPosition < itemDistanceFromTop + bufferAbove + itemFromTopArray[index].offsetHeight) {
        functionToRun(itemFromTopArray[index]);
    }
}

//=====================================================================
// Debounce function
//=====================================================================
export function debounce(functionToDebounce, delay) {
    let timeout;
    return function (...args) {
        const runLater = () => {
            clearTimeout(timeout);
            functionToDebounce(...args);
        }
        clearTimeout(timeout);
        timeout = setTimeout(runLater, delay);
    }
}


//=====================================================================
// Remove Hastag from URL
//=====================================================================
export function removeHashOnButtonClick(button) {
    //let windowURL = window.location.href;

    //button.addEventListener("click", (event) => {
        // Prevent default behavior of navigating to the anchor
        //event.preventDefault();
        
        let buttonHref = button.getAttribute("href");
        let targetSection = document.querySelector(buttonHref); // Find the section to scroll to
        
        // Smooth scroll to the target section
        //if (targetSection) {
        //    targetSection.scrollIntoView({ behavior: "smooth" });
        //}
        
        // Update the URL without the hash
        //let windowURL = window.location.href.split("#")[0]; // Remove any existing hash
        //history.replaceState(null, null, windowURL);
        
    //})
}